import { render, staticRenderFns } from "./sysRole.vue?vue&type=template&id=f6f6d4f4&scoped=true"
import script from "./sysRole.vue?vue&type=script&lang=js"
export * from "./sysRole.vue?vue&type=script&lang=js"
import style0 from "../styles/sysRole.scss?vue&type=style&index=0&id=f6f6d4f4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f6d4f4",
  null
  
)

export default component.exports